import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { getHousehold } from '../planner/plannerApi';

// Once the account has a household it keeps it for the session, so the check runs once
let knownToHaveHousehold = false;

interface RequireHouseholdProps {
  children: React.ReactElement;
}

/**
 * An account without a household reaches no data (the API answers 404): finances and
 * investments send it to create a household or accept an invitation first.
 */
export default function RequireHousehold({ children }: RequireHouseholdProps) {
  const [state, setState] = useState<'loading' | 'yes' | 'no'>(knownToHaveHousehold ? 'yes' : 'loading');

  useEffect(() => {
    if (knownToHaveHousehold) return undefined;
    let active = true;
    getHousehold()
      .then(household => {
        knownToHaveHousehold = !!household;
        if (active) setState(household ? 'yes' : 'no');
      })
      // On a failed check the page itself shows the error
      .catch(() => { if (active) setState('yes'); });
    return () => { active = false; };
  }, []);

  if (state === 'loading') {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>;
  }
  if (state === 'no') return <Navigate to="/casa/agregado" replace />;
  return children;
}
